// src/common.ts
var Provider = /* @__PURE__ */ ((Provider2) => {
  Provider2["VGTV"] = "vgtv";
  Provider2["AB"] = "ab";
  return Provider2;
})(Provider || {});
var Newsroom = /* @__PURE__ */ ((Newsroom2) => {
  Newsroom2["VG"] = "vg";
  Newsroom2["AB"] = "ab";
  return Newsroom2;
})(Newsroom || {});

export {
  Provider,
  Newsroom
};
